import { MockFactory } from '@tino-frontend/mocks'
import {
  CheckUnicoResultResponse,
  CheckUnicoResultResponseResult,
} from '@types'

export const CheckUnicoResultResponseApprovedMock =
  new MockFactory<CheckUnicoResultResponse>({
    result: CheckUnicoResultResponseResult.APPROVED,
  })
